export default "__VITE_ASSET__xULV5Puy__"